import * as React from 'react';
import { SendOTPDto, SendOTPDtoImpl } from '../../../core/dto/otp/sendotp/sendotpdto';
import { ToneDto } from '../../../core/dto/tonedto';
import { BaseContext } from '../../../utils/basecontext';
import { Strings } from '../../../utils/resources/strings';
import { AlertComponent } from '../../toolkit/alert/alertcomponent';
import { AlertType } from '../../toolkit/alert/alerttype';
import { CheckboxComponent } from '../../toolkit/checkbox/checkboxcomponent';
import { MsisdnFloatingTextComponent } from '../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { LoaderComponent } from '../../toolkit/loader/loadercomponent';
import { MSISDNValidation } from '../../toolkit/msisdnvalidation/msisdnvalidation';
import { LandingPagePlayerWithSeekBarComponent } from '../../toolkit/player/landingpageplayer/landingpageplayerwithseekbarcomponent';
import { UIComponentHandler, UIDataModel } from '../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../toolkit/uicomponentview';
import { LandingPageListComponent } from '../home/landingpagelist/landingpagelistcomponent';
import { LoaderWrapperComponent } from '../popup/loaderwrappercomponent';
import { OTPVerificationComponent } from '../popup/otpverification/otpverificationcomponent';
import { PopUpWrapperComponent } from '../popup/popupwrappercomponent';
import { SubscriptionPlanComponent } from '../popup/subscription_plan/subscriptionplancomponent';
import { LandingErrorComponent } from './error/landingpageerrorcomponent';
import { LandingPageCSSStyle } from './landingcss';
import './landingpage-style.css';
import { LandingPageComponentHandler, LandingPageComponentProps, LandingPageComponentState } from './landingpagecomponent';


export class LandingPageViewImpl extends UIComponentViewImpl<UIDataModel> {
    playerComponent: LandingPagePlayerWithSeekBarComponent | null;
    checkboxComponent: CheckboxComponent;
    contactNumber: MsisdnFloatingTextComponent;
    loaderWrapperComponent: LoaderWrapperComponent;


    private popUpComponent: PopUpWrapperComponent;
    // private imageLoaderCSSStyle: ImageLoaderCSSStyle;


    constructor(context: BaseContext, handler: UIComponentHandler) {
        super(context, handler);
        // this.imageLoaderCSSStyle = new LandingPageImageLoaderCSSStyleImpl(context);
    }

    bindHandlers() {
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.showToneOptionsPopup = this.showToneOptionsPopup.bind(this);
        this.showOTPView = this.showOTPView.bind(this);
    }

    draw(props: LandingPageComponentProps, state: LandingPageComponentState, cssStyle: LandingPageCSSStyle): JSX.Element | boolean {
        super.draw(props, state, cssStyle);

        console.log("---buy tone: " + props.context.getResources().getString(Strings.buytone));

        return (
            <>
                {
                    state.isError && <LandingErrorComponent context={props.context} />}
                {
                    !state.isError &&
                    <>
                        <LandingPageListComponent isBannerRequired={true} isNavigationPathRequired={true} categoryName={state.categoryName} routeNextFeature={props.routeNextFeature} context={this.getUIProps().context} isFlashMessageRequired={false} categoryId={state.categoryId} language={state.language} />
                        <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context} />
                        <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context} />

                    </>
                }
            </>
        );
    }

    onConfirmClick(): void {
        (this.getUIComponentHandler() as LandingPageComponentHandler).onConfirmClick();
    }


    showLoader() {

        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true, <LoaderComponent context={this.getUIProps().context} />);
    }

    dismissLoader() {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getLikeCount(toneDto: ToneDto): string {
        return toneDto.getLikeCount() === undefined ? "0" : toneDto.getLikeCount();
        // let formattedCount = this.getContext().getResources().getString(Strings.zero);

        // if(toneDto.getLikeCount() !== undefined)
        // {      
        //     if(+toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = toneDto.getLikeCount();
        //     }
        //     else if(+toneDto.getLikeCount() >= +this.getContext().getResources().getString(Strings.thousand) && +toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.thousand)) + this.getContext().getResources().getString(Strings.K);
        //     }
        //     else
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.million)) + this.getContext().getResources().getString(Strings.M);
        //     }

        //     return formattedCount.replace("."+ this.getContext().getResources().getString(Strings.zero), "");
        // }
        // else
        // {
        //     return formattedCount;
        // }
    }
    closePopup() {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    validate(): boolean {
        if (this.contactNumber.validate()) {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);


            if (!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength)) {
                this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }


            return true;
        }
        return false;
    }
    showPopup(id: string, msg: string, type: AlertType): void {
        this.closePopup();
        if (type === AlertType.WARN) {

            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={() => ''} context={this.getUIProps().context} />);

        }

        else {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context} />);

        }

    }

    showOTPView() {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
            <OTPVerificationComponent toneDto={(this.getUIState() as LandingPageComponentState).toneDto} id={this.getUIProps().context.getResources().getString(Strings.buy_now)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context} />);
    }
    getOTPData(): SendOTPDto {
        let request = new SendOTPDtoImpl();
        request.setMsisdn(this.getContext().getUserContext().getMsisdn());

        return request;
    }
    showToneOptionsPopup(id: string): void {
        this.playerComponent !== null && this.playerComponent !== undefined && this.playerComponent.onStopClicked();

        if (id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" +
            this.getUIProps().context.getResources().getString(Strings.subscription)) {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <SubscriptionPlanComponent id={this.getUIProps().context.getResources().getString(Strings.buy_now)} toneDto={(this.getUIState() as LandingPageComponentState).toneDto} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context} />);
        }
    }

    onPlayComplete(): void {
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }

    onPlayStop(): void {
        this.playerComponent !== null && this.playerComponent.onPlayStop();
    }

    private onPlayClicked(): void {
        if (this.playerComponent !== null) {
            this.getContext().getPlayerManager().startPlay(
                (this.getUIState() as LandingPageComponentState).toneDto.getToneUrl(), this);
            // this.getContext().getPlayerManager().getAudioPlayer().getAudio();
        }
    }


    private onStopClicked(): void {
        this.getContext().getPlayerManager().stopPlay();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/landingview.tsx